import { Component,Inject, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef } from '@angular/core';
import { IboxtoolsItem } from 'app/models/iboxtools-item';
import { PrimeNGConfig } from 'primeng/api';
import { exit } from 'process';

declare var jQuery:any;

@Component({
  selector: 'iboxtools',
  templateUrl: 'iboxtools.template.html',
  styleUrls: ['./iboxtools.component.css']
})
export class IboxtoolsComponent implements OnInit, OnChanges {
  @Input() PeriodList: any; 
  @Input() CurrentPeriod: number = 0; 
  @Input() HideClose: boolean = true; 
  @Input() EditForm: boolean = true; 
  @Input() enableBack: boolean = false; 
  @Input() IsEditing: boolean = false; 
  @Input() isHistory: boolean = false; 
  @Input() DateInit: any = null; 
  @Input() DateEnd: any = null; 
  @Input() Previous: any = null; 
  @Input() Next: any = null; 
  @Input() Title: string = ""; 
  @Input() onlyNew: boolean;
  @Input() Errors: boolean=false;
  @Input() Permiso: boolean=true;
  @Input() enableCut: boolean=true;
    
  @Output() PeriodChange = new EventEmitter<number>();
  @Output() EditChange = new EventEmitter<boolean>();
  @Output() NewChange = new EventEmitter<boolean>();
  @Output() SaveChange = new EventEmitter<boolean>();  
  @Output() CutChange = new EventEmitter<boolean>();
  @Output() DeleteChange = new EventEmitter<boolean>();
  @Output() CancelChange = new EventEmitter<boolean>();
  @Output() BackChange = new EventEmitter<boolean>();
  

  constructor(
              private primengConfig: PrimeNGConfig
              ) { }

  displayModal: boolean;
  
  openDialog() {
        this.displayModal = true;
  }

  ngOnInit(): void
  {
    /*if (this.PeriodList == undefined || this.PeriodList.length == 0) {
      this.isHistory = false;
    }*/
  }
  
  ngOnChanges(changes: SimpleChanges) {
    if(changes.DateInit && changes.DateInit.currentValue != 'undefined'){
      this.DateInit = changes.DateInit.currentValue;
    }
    if(changes.DateEnd && changes.DateEnd.currentValue != 'undefined'){
      this.DateEnd = changes.DateEnd.currentValue;
    }
    if(changes.Title){
      this.Title = changes.Title.currentValue;
    }
    if(changes.IsEditing){
      this.IsEditing = changes.IsEditing.currentValue;
    }

    if(changes.onlyNew){
      this.onlyNew = changes.onlyNew.currentValue;
    }
    
    //if(changes.PeriodList.currentValue != 'undefined'){
    if(changes.PeriodList){
      this.PeriodList = changes.PeriodList.currentValue;
      
      var validToday = -1;
      if(this.PeriodList?.length > 0){ 
        //Primero ordeno la lista del mas nuevo al mas antiguo
        this.PeriodList.sort((a, b) => new Date(b.desde).getTime() - new Date(a.desde).getTime());

        if(this.CurrentPeriod == 0 || this.CurrentPeriod == undefined)
        {
          //Busca el vigente sino muestra el ultimo
          this.CurrentPeriod = 0;
          let fecha = new Date();

          for(let i=0; i<this.PeriodList.length;i++)
          {
            if( ( fecha.getTime() >= Date.parse(this.PeriodList[i].desde) ) && 
                ( fecha.getTime() <= Date.parse(this.PeriodList[i].hasta) ) )
            {
              validToday = i;
              exit;
            }
          }

          if(validToday==-1) validToday = 0;

        } else
        {
          //Muestra el que se manda por parametro
          let index = this.PeriodList.findIndex(x => x.id == this.CurrentPeriod);
          if (index != -1)
          {
            validToday = index;
          } else
          {
            validToday = 0;
          }
          
        }

        let _period = this.PeriodList[validToday];

        this.DateInit = _period.desde;
        this.DateEnd = _period.hasta;
        this.Previous = this.PeriodList[validToday-1];
        this.Next = this.PeriodList[validToday+1];

        this.changePeriod(validToday);
      }
    }  
      
  }

  public edit(e):void {
    this.EditChange.emit(this.IsEditing);
  }

  public save(e):void {
    this.SaveChange.emit();
  }

  public back(e):void {
    this.BackChange.emit();
  }

  public new(e):void {
    //this.IsEditing = true;
    this.NewChange.emit(false);
  }

  public delete(e):void {
    this.DeleteChange.emit(false);
  }

  public cut(e):void {
    this.CutChange.emit(false);
  }

  public cancel(e):void {
    this.CancelChange.emit(false);
  }

  public previous(e):void {
    if (this.Previous){
      this.Next =  this.PeriodList[this.CurrentPeriod];
      if (this.CurrentPeriod>0){
        this.CurrentPeriod--;
        this.changePeriod(this.CurrentPeriod);
      }
    }
  }

  public next(e):void {
    if (this.Next){
      this.Previous =  this.PeriodList[this.CurrentPeriod];
      if (this.PeriodList.length-1>this.CurrentPeriod){
        this.CurrentPeriod++;
        this.changePeriod(this.CurrentPeriod);
      }
    }
  }

  public changePeriod(index){
    this.IsEditing = false;
    let _period = this.PeriodList[index]
    
    this.CurrentPeriod = index;
    this.Previous = this.PeriodList[index-1];
    this.Next = this.PeriodList[index+1];

    this.DateInit = _period.desde;    
    this.DateEnd = _period.hasta;

    this.PeriodChange.emit(this.PeriodList[index].id);
    this.displayModal = false;
  }

  public collapse(e):void {
    e.preventDefault();
    let ibox = jQuery(e.target).closest('div.ibox');
    let button = jQuery(e.target).closest('i');
    let content = ibox.children('.ibox-content');
    content.slideToggle(200);
    button.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
    ibox.toggleClass('').toggleClass('border-bottom');
    setTimeout(function () {
      ibox.resize();
      ibox.find('[id^=map-]').resize();
    }, 50);
  }

  public close(e):void {
    e.preventDefault();
    let content = jQuery(e.target).closest('div.ibox');
    content.remove();
  }


}
